__turbopack_context__.v({
  "appear": "LoadingCircle-module-scss-module__VOTHQW__appear",
  "root": "LoadingCircle-module-scss-module__VOTHQW__root",
  "spin": "LoadingCircle-module-scss-module__VOTHQW__spin",
});
